import getLogger from "@ignitesales/logger-es";
import React from "react";
import { QuestionShape } from "@ignitesales/neuro-application/src/shapes/index.mjs";
import QuestionText from "@ignitesales/neuro-application/src/components/questions/QuestionText.jsx";
import { FormattedHTMLMessage, useIntl } from "react-intl";
import MessageIfPresent from "@ignitesales/neuro-application/src/components/MessageIfPresent.jsx";
import classNames from "classnames";
import SimpleSelect from "../../SimpleSelect";

const logger = getLogger({ component: "Dropdown" });

const Dropdown = (props) => {
  const {
    className,
    valueChanged,
    question,
    value: { value = {} } = {},
  } = props;

  const intl = useIntl();

  const answers = question.answers;
  const currentValue = value && value.length > 0 ? value[0] : value;
  let selectedIndex = answers.findIndex((a) => a.key === currentValue);

  const classes = classNames(className, {
    dropdown: true,
  });

  const getSelectOptions = () => {
    return answers.map((option, index) => {
      return (
        <option key={index} value={index}>
          {intl.formatMessage({ id: `${question.appkey}.${option.key}` })}
        </option>
      );
    });
  };

  const onChange = ({ value: targetIndex }) => {
    if (
      targetIndex >= 0 &&
      targetIndex < answers.length &&
      answers[targetIndex] &&
      answers[targetIndex].key
    ) {
      valueChanged(answers[targetIndex].key);
    } else {
      valueChanged([]);
    }
  };

  const message = intl.formatMessage({ id: "pleaseSelect" });

  const icon = (
    <MessageIfPresent id={`${props.appkey}.icon`}>
      <div className="text-center pb-4 py-4 question__icon">
        <FormattedHTMLMessage id={`${props.appkey}.icon`} />
      </div>
    </MessageIfPresent>
  );

  const options = answers.map(({ key }, index) => ({
    value: index,
    label: intl.formatMessage({ id: `${question.appkey}.${key}` }),
  }));

  return (
    <section className={classes}>
      {icon ? icon : null}
      <QuestionText question={question} />
      <div className="dropdown__container">
        <SimpleSelect
          value={options[selectedIndex]}
          options={options}
          onChange={onChange}
          isSearchable={false}
        />
      </div>
    </section>
  );
};

Dropdown.propTypes = {
  data: QuestionShape,
};

export default Dropdown;
